
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Bushirenearmepune() {



  const cardData =
  {
    keyword: ' Bus Hire Near Me Pune',
    heading: 'Vaishnavi Travels: Bus Hire Near Me Pune',
    headingDescription: 'Vaishnavi Travels offers convenient and affordable Bus Hire Near Me in Pune, making group travel simple and stress-free. Our buses are well-maintained with spacious seating, strong air-conditioning, and ample luggage space to ensure a comfortable ride for weddings, corporate events, school trips, or family tours. With experienced drivers, punctual pickups, and flexible booking options, we provide a reliable solution for both short city rides and long outstation journeys. Whether you need a bus for a social gathering, religious yatra, or holiday tour, Vaishnavi Travels ensures safe, comfortable, and hassle-free travel right from your doorstep in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

    "topPlaces": [
      {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, its mighty gates, gardens, and ruins narrate tales of Maratha pride. Though partially destroyed by fire in 1828, its charm continues to draw thousands. The light-and-sound show in the evening brings alive the grandeur of Bajirao and Mastani. Visitors love exploring its historic corridors and courtyards. Shaniwar Wada is Pune’s proud heritage landmark."
      },
      {
        "title": "Aga Khan Palace",
        "description": "The Aga Khan Palace, built in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum with Gandhi’s belongings and photographs. The palace’s Italian arches and sprawling gardens add architectural charm. Its calm and serene ambiance makes it a popular tourist spot. Aga Khan Palace is Pune’s historic and inspirational gem."
      },
      {
        "title": "Sinhagad Fort",
        "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. The fort sits atop a hill, offering trekking trails and panoramic views of the Sahyadris. Visitors explore bastions, temples, and memorials that echo Maratha bravery. Monsoon adds mist and waterfalls, making the trek even more scenic. Locals serve rustic delicacies like pithla-bhakri at the fort. Sinhagad is Pune’s blend of history, nature, and adventure."
      },
      {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. Established more than 125 years ago, the temple houses a magnificent idol adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also renowned for its charitable and cultural initiatives. Devotees and tourists alike are drawn to its vibrant spiritual aura. Dagdusheth Temple is Pune’s divine and cultural heart."
      },
      {
        "title": "Pataleshwar Cave Temple",
        "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The temple features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city center, it offers peace and a spiritual retreat. Its architecture showcases ancient Indian craftsmanship. Evening prayers and chants enhance the temple’s mystical ambiance. Pataleshwar is Pune’s hidden spiritual heritage gem."
      },
      {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, sculptures, musical instruments, and daily-use antiques. The recreated Mastani Mahal is a highlight of the museum. History enthusiasts and students find it highly educational and fascinating. The museum preserves traditions spanning centuries of Indian culture. It is Pune’s proud showcase of heritage and art."
      },
      {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill, one of Pune’s oldest heritage landmarks, offers a panoramic view of the city. At the hilltop stands the Parvati Temple, dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa era, it also houses museums and smaller shrines. Visitors climb 103 steps to reach the temple, making it a mix of devotion and adventure. Sunrise and sunset views from here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
      },
      {
        "title": "Osho Ashram",
        "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub for spirituality and wellness. Spread across lush gardens, it attracts seekers from all over the world. The ashram offers meditation sessions, yoga practices, and personal growth workshops. Japanese Zen gardens and peaceful meditation halls enhance the experience. It is a haven for peace, rejuvenation, and mindfulness. Osho Ashram is Pune’s international center of tranquility."
      },
      {
        "title": "Pu La Deshpande Garden (Okayama Friendship Garden)",
        "description": "Pu La Deshpande Garden, inspired by the Korakuen Garden in Japan, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and lush green lawns. Families enjoy picnics, photography, and peaceful strolls in its serene setting. The garden symbolizes Indo-Japanese cultural friendship. Seasonal flowers and manicured spaces attract nature lovers. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
      },
      {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend destination near Pune. The dam supplies water to the city while offering scenic views of hills and flowing waters. During monsoon, the overflowing dam creates spectacular sights. Street vendors sell hot corn and tea along the banks, adding to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat for families and travelers alike."
      }
    ],


    "services": [
  {
    "name": "Nearest Bus Hire in Pune",
    "description": "Quick-response bus hire services in Pune located close to your area, ensuring minimal travel time for pick‑ups. Ideal for same‑day bookings for weddings, family functions, corporate events, or short errands. Vehicles maintained regularly, drivers familiar with local routes, and transparent pricing so no surprises."
  },
  {
    "name": "Local Bus Rental Pune",
    "description": "Local bus rental options within Pune city for short distance trips—party functions, temple visits, sight‑seeing, weddings. These buses are optimized for comfort and convenience, offering frequent stops, easy access, and seating suitable for urban travel with passengers and light luggage."
  },
  {
    "name": "Bus on Rent Near Me Pune",
    "description": "On‑demand bus rentals close to your location in Pune, available via phone or app booking. Drivers are assigned nearby, ensuring punctual pick‑ups and drop‑offs. Good for urgent group travel, impromptu events, or when central availability matters most."
  },
  {
    "name": "Pune Bus Services Nearby",
    "description": "Comprehensive list of bus services in your local Pune area offering a variety of vehicles—regular buses, deluxe, AC/non‑AC—for different use cases like family outings, weddings, school trips. Includes contactless booking, map‑based selection to see what's near you, and standardized safety norms."
  },
  {
    "name": "Affordable Bus Hire Near Me Pune",
    "description": "Budget‑friendly bus hire services located close by in Pune to reduce travel time and fuel charges. Non‑AC and standard bus options for homes, functions, or short trips. Transparent cost breakdown, no hidden fees, with well‑maintained vehicles and basic comfort included."
  },
  {
    "name": "Nearby Bus for Functions Pune",
    "description": "Function‑specific buses near you in Pune for events like weddings, birthdays, corporate gatherings. Options to decorate, add signage, or customize interiors. Drivers familiar with event traffic patterns, ensuring timely arrival even in busy areas."
  },
  {
    "name": "Book Bus Close to Me in Pune",
    "description": "Easy‑book service for buses located nearest to your specified pickup point in Pune. Instant quotes, maps to show available options, choice between AC/non‑AC, mini or full‑size, and flexible scheduling. Especially useful when organizing group movement within the city."
  },
  {
    "name": "Nearest AC Bus Rental Pune",
    "description": "Air‑conditioned buses located in your vicinity in Pune for comfortable travel during hot weather or long hours. Vehicles are well‑maintained with clean interiors, cool air, and seats suitable for formal attire or guests carrying gifts. Perfect for weddings, receptions, or events in the summer."
  },
  {
    "name": "Non AC Local Bus Hire Pune",
    "description": "Non‑AC local bus hire options close to your location in Pune for shorter trips or when weather is mild. This is a more economical choice while still offering safety, basic amenities, reliable service, and seating that’s comfortable enough for everyday use or function transfers."
  },
  {
    "name": "Mini Bus Near Me Pune",
    "description": "Compact mini‑bus rental services in your vicinity in Pune for smaller groups (15‑25 people). Highly maneuverable, suitable for narrow roads, guest pickups at multiple points, or navigating crowded areas. Ideal for small family groups, work outings or local tours."
  },
  {
    "name": "Tempo Traveller Near Me Pune",
    "description": "Tempo Traveller options close to you in Pune for flexible group travel. These vehicles are ideal for mid‑sized gatherings, weekend trips, or guests who want more privacy. Often offer reclining seats, music system, and flexibility in itinerary—perfect for both city and nearby outstation travel."
  },
  {
    "name": "Family Trip Bus Near Me Pune",
    "description": "Bus rentals close by in Pune for family trip itineraries—temple visits, day‑out, picnic sites, or beach trips nearby. Vehicles with comfortable seating, space for luggage, possible cooler boxes, and drivers who understand scenic routes, stops, and family logistics."
  },
  {
    "name": "School Bus Rental Near Me Pune",
    "description": "Safe and reliable school bus services based near your location in Pune for school events, sports meets, excursions, or daily transport. Vehicles equipped with reliable safety features, trained drivers, scheduled pickup‑drop timings, and supervision options for young students."
  }
],
"tableData": [
  ["Nearest Bus Hire in Pune", "Local Bus Rental Pune"],
  ["Bus on Rent Near Me Pune", "Pune Bus Services Nearby"],
  ["Affordable Bus Hire Near Me Pune", "Nearby Bus for Functions Pune"],
  ["Book Bus Close to Me in Pune", "Nearest AC Bus Rental Pune"],
  ["Non AC Local Bus Hire Pune", "Mini Bus Near Me Pune"],
  ["Tempo Traveller Near Me Pune", "Family Trip Bus Near Me Pune"],
  ["School Bus Rental Near Me Pune"]
],




   "whychoose": [
  {
    "WhyChooseheading": "Convenient Bus Hire Near Me in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers fast and accessible bus hire services across Pune, making local group travel simple and stress-free."
  },
  {
    "WhyChooseheading": "Wide Range of Buses Available Near You",
    "WhyChoosedescription": "From mini-buses to large 50-seaters, we have a variety of well-maintained buses available close to your location in Pune."
  },
  {
    "WhyChooseheading": "Timely Pickup and Drop at Your Doorstep",
    "WhyChoosedescription": "We offer prompt bus services with pickup and drop-off at your preferred location for maximum convenience."
  },
  {
    "WhyChooseheading": "Flexible Rental Options for All Needs",
    "WhyChoosedescription": "Choose hourly, daily, or trip-based rentals that fit your travel schedule and group size—perfect for any occasion."
  },
  {
    "WhyChooseheading": "Experienced Drivers Who Know Pune Well",
    "WhyChoosedescription": "Our drivers are familiar with all major routes and localities in Pune, ensuring efficient and safe transportation."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Buses Near You",
    "WhyChoosedescription": "Each bus undergoes regular maintenance and sanitation to guarantee a clean and comfortable ride every time."
  },
  {
    "WhyChooseheading": "Affordable Local Bus Hire with No Hidden Charges",
    "WhyChoosedescription": "Enjoy competitive rates that include fuel, tolls, and driver allowance—clear and transparent pricing always."
  },
  {
    "WhyChooseheading": "24/7 Booking Support Across Pune",
    "WhyChoosedescription": "Wherever you are in Pune, our support team is available round-the-clock to assist with bookings and travel arrangements."
  }
]






















  }










const faqData = [
  [
    {
      question: 'Can I hire a bus near me in Pune with Vaishnavi Travels?',
      answer: 'Yes, Vaishnavi Travels offers quick and reliable bus hire services across all major areas in Pune. Whether you are located in Kothrud, Hadapsar, Baner, or any other locality, we can arrange prompt pickups and provide the right vehicle to match your travel needs with minimal wait time.',
    },
    {
      question: 'What types of buses are available for hire near me?',
      answer: 'We provide a wide range of buses including tempo travellers, minibuses, luxury coaches, and AC/non-AC options in various seating capacities such as 17, 27, 32, and 50-seaters. Our diverse fleet ensures that you’ll find a suitable vehicle close to your location for family functions, group tours, or corporate travel.',
    },
    {
      question: 'How fast can I get a bus near me in Pune?',
      answer: 'Depending on your location and vehicle availability, we can often arrange a bus within 1 to 3 hours of your booking. For urgent requirements, our customer support team works on priority to connect you with the nearest available vehicle and driver to minimize waiting time.',
    },
    {
      question: 'Are your buses near me well-maintained and clean?',
      answer: 'Absolutely. Every bus in our fleet is regularly maintained, deeply cleaned before each trip, and equipped with comfortable seating and air conditioning (on applicable models). We take hygiene, safety, and vehicle upkeep very seriously so you get a smooth, worry-free ride every time.',
    },
    {
      question: 'Do the bus rentals near me come with drivers?',
      answer: 'Yes, all our bus hires come with professional, licensed drivers who are courteous, punctual, and familiar with Pune routes. Whether it’s local or outstation travel, our drivers ensure a safe and pleasant journey for all passengers.',
    },
    {
      question: 'Is it possible to rent a bus near me for just a few hours?',
      answer: 'Yes, we offer flexible rental durations including hourly packages. Whether you need a vehicle for a short airport transfer, a few hours for a city event, or a full-day outing, we have options that fit your exact requirement and budget.',
    },
    {
      question: 'How can I find and book a bus near me quickly?',
      answer: 'You can book a bus quickly by visiting our website, using our mobile app, or calling our support number. Just share your location, travel plan, and preferred timing, and we’ll suggest the nearest available bus along with a competitive quote instantly.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Ajay Kulkarni",
    position: "Software Engineer",
    feedback:
      "I urgently needed a bus near Baner for a team outing, and Vaishnavi Travels delivered impressively. The booking process was fast, the bus arrived on time, and the vehicle was in top condition. Our team of 25 people had a smooth and enjoyable ride to Lonavala. The driver was courteous and handled the journey professionally. I’ll definitely choose them again for future trips.",
    rating: 5,
  },
  {
    name: "Mrs. Neeta Pawar",
    position: "Event Organizer",
    feedback:
      "We needed a last-minute bus for a family gathering, and Vaishnavi Travels arranged one within just 2 hours. The bus was very clean, air-conditioned, and the seats were extremely comfortable. Their support team stayed in touch until the vehicle reached us, which made the entire experience stress-free. Truly reliable service for anyone looking to hire a bus near them in Pune.",
    rating: 5,
    style: "style-2",
  },
];






































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire Near Me Pune",
  "image": "https://vaishnavitravel.com/assets/images/bus-hire-near-me-pune.jpg",
  "description": "Looking for a bus hire near you in Pune? Vaishnavi Travels offers local and nearby bus rental services, including AC, Non-AC, Mini Buses, and Tempo Travellers for family trips, functions, and school events.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3512"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/bus-hire-near-me-pune"
  }
};



  return (
    <div>

<Helmet>
  <title>Bus Hire Near Me Pune | Local Bus Rental & Booking | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Looking for a bus hire near you in Pune? Vaishnavi Travels offers local and nearby bus rental services, including AC, Non-AC, Mini Buses, and Tempo Travellers for family trips, functions, and school events."
  />
  <meta
    name="keywords"
    content="Nearest Bus Hire in Pune, Local Bus Rental Pune, Bus on Rent Near Me Pune, Pune Bus Services Nearby, Affordable Bus Hire Near Me Pune, Nearby Bus for Functions Pune, Book Bus Close to Me in Pune, Nearest AC Bus Rental Pune, Non AC Local Bus Hire Pune, Mini Bus Near Me Pune, Tempo Traveller Near Me Pune, Family Trip Bus Near Me Pune, School Bus Rental Near Me Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushirenearmepune;